import { Component, EventEmitter, Input, Output } from '@angular/core';

export const typeToIconMap = {
  add: 'add_circle',
  view: 'remove_red_eye',
  edit: 'edit',
  remove: 'cancel',
  upload: 'file_upload'
} as const

export const typeToPathMap = {
  edit: 'assets/icons/chip_close.svg',
  add: 'add_circle',
  view: 'remove_red_eye',
  remove: 'assets/icons/close-red.svg',
  upload: 'file_upload'
}

const useIcon = {
  add: true,
  view: true,
  edit: true,
  remove: false,
  upload: true
}

@Component({
  selector: 'app-base-btn',
  templateUrl: './base-btn.component.html',
  styleUrls: ['./base-btn.component.scss']
})
export class BaseBtnComponent {

  @Input() type: 'add' | 'view' | 'edit' | 'remove' | 'upload' = 'add';
  @Output() action = new EventEmitter();
  @Input() disabled: boolean = false;
  @Input() hideBtnOnDisabled: boolean = false;

  typeToIconMap = typeToIconMap
  typeToPathMap = typeToPathMap

  get hideBtn(){
    return this.disabled && this.hideBtnOnDisabled
  }

  get useIcon(){
    return useIcon[this.type]
  }

  newAction() {
    if (this.disabled) {
      return
    }
    this.action.emit();
  }
}
